(function() {
	'use strict';

	angular.module('prelimApp')
			.controller('PrelimController', PrelimController);

	PrelimController.$inject = [ '$scope', 'CONST_PRELIM', 'PrelimService',
			'CommonService', '$window', '$filter', '$http', '$uibModal', 'NgTableParams', 'EVENT', '$state', '$base64' ];

	function PrelimController($scope, CONST_PRELIM, PrelimService,
			CommonService, $window, $filter, $http, $uibModal, NgTableParams, EVENT, $state, $base64) {
		var prelimCtr = this;
		var self = $scope;
		self.CONST_PRELIM = CONST_PRELIM;
		
		prelimCtr.search = {};
		prelimCtr.search.toDate = new Date();
		prelimCtr.search.fromDate = new Date();
		
		prelimCtr.datePickerOpenStatus = {};
		prelimCtr.datePickerOpenStatus.fromDate = false;
		prelimCtr.datePickerOpenStatus.toDate = false;
		
		prelimCtr.openCalendar = function(date) {
			$scope.clearMessage();
			prelimCtr.datePickerOpenStatus[date] = true;
			prelimCtr.validateDates();
		};
		
		prelimCtr.validateDates = function() {
			$scope.clearMessage();

			var currentDate = new Date();
			var toDate = moment(prelimCtr.search.toDate, "DD/MM/YYYY");
			var fromDate = moment(prelimCtr.search.fromDate,
					"DD/MM/YYYY");
			if (currentDate < fromDate) {
				prelimCtr.checkDate = true;
				$scope
						.addAlert(
								'Vui lòng chọn Từ Ngày bằng hoặc nhỏ hơn ngày hiện tại.',
								'error');
			} else if (toDate.diff(fromDate) < 0) {
				prelimCtr.checkDate = true;
				$scope.addAlert(
						'Vui lòng chọn Đến Ngày lớn hơn hoặc bằng Từ ngày.',
						'error');
			/*} else if ((toDate - fromDate) / (1000*60*60*24) > 60) {
				prelimCtr.checkDate = true;
				$scope.addAlert(
						'Vui lòng chọn Từ ngày, Đến Ngày trong khoảng 2 tháng, liên hệ IT để xuất báo cáo!',
						'error');*/
			} else {
				prelimCtr.checkDate = false;
			}
		};

		prelimCtr.fromDateOptions = {
			maxDate : new Date()
		};
		prelimCtr.toDateOptions = {
			maxDate: new Date().setDate(new Date().getDate() + 1)
		};

		prelimCtr.searchPrelim = function() {
			prelimCtr.collectionParams.page(1);
			prelimCtr.collectionParams.count(20);
			prelimCtr.collectionParams.total(0);
			prelimCtr.collectionParams.reload();
		}

		prelimCtr.searchAgent = function() {
			var code = prelimCtr.search.agentCode;
			if (code != undefined || code != '') {
				var numCode = Number(code);
				if (numCode < 10000000)
					numCode += 60000000;
				prelimCtr.search.agentCode = numCode.toString();
			}
		};

		prelimCtr.popupUpdatePrelimInfo = function(prelimID) {
			prelimCtr.animationsEnabled = true;
			var modalInstance =
			// show dialog
			$uibModal
					.open({
						animation : prelimCtr.animationsEnabled,
						templateUrl : '../../partial?uri=ga/prelim/layouts/prelim-update-dialog',
						controller : 'PrelimUpdateDialogController as prelimDlgCtr',
						size : 'lg',
						resolve : {
							prelimID : function() {
								return prelimID;// tranfer data for dialog
							}
						}
					});
			modalInstance.result.then(function() {
				prelimCtr.searchPrelim();
				$scope.loading = false;
				modalInstance = null;
			}, function() {
			});
		};

		prelimCtr.param = {};
		
		prelimCtr.collectionParams = new NgTableParams(
		{
			page : 1,
			count : 20
		},
		{
			total : 0,
			counts : [20],
			defaultSort : 'desc',
			getData : function(params) {
				prelimCtr.param.uri = "search";
				prelimCtr.param.page = params.page();
				prelimCtr.param.size = params.count();
				prelimCtr.param.sort = params.sorting();
				prelimCtr.param.officeCode = prelimCtr.search.officeCode;
				prelimCtr.param.clientCode = prelimCtr.search.clientCode;
				prelimCtr.param.agentCode = prelimCtr.search.agentCode;
				prelimCtr.param.goodwillCode = prelimCtr.search.goodwillCode;
				prelimCtr.param.status = prelimCtr.search.status;
				prelimCtr.param.fromDate = prelimCtr.search.fromDate;
				prelimCtr.param.toDate = prelimCtr.search.toDate;

				$scope.loading = true;
				return PrelimService.get(prelimCtr.param).$promise
						.then(function(result) {
							$scope.loading = false;
							params.total(result.totalElements);
							return result.content;
						});
			}
		});
		
		$scope.$on(EVENT.changeOffice, function(event, args) {
			if (event.name = 'CHANGE_OFFICE') {
				$state.go($state.current, {}, {
					reload : true
				});
			}
		});
		
	}
})();
